function wrapInFragment(nodes) {
  const fragment = document.createDocumentFragment();
  fragment.append(...nodes);
  return fragment;
}
function wrapInList(nodes, nodeName) {
  const listElement = document.createElement(nodeName);
  listElement.append(...nodes);
  return listElement;
}
function wrapInLi(nodes) {
  const listItemElement = document.createElement('li');
  listItemElement.append(...nodes);
  return listItemElement;
}

/**
 * Activates `Range.prototype.cloneContents` override that ensures in the cloned contents:
 * - there are no <li> children elements without parent <li> element
 * - there are no <li> elements without parent <ol> or <ul> elements
 */
export function patchRangeCloneContents() {
  const originalCloneContents = Range.prototype.cloneContents;
  Range.prototype.cloneContents = function cloneContents() {
    const contents = originalCloneContents.apply(this);
    if (this.commonAncestorContainer.nodeName === 'OL' || this.commonAncestorContainer.nodeName === 'UL') {
      return wrapInFragment([wrapInList([...contents.childNodes], this.commonAncestorContainer.nodeName)]);
    }
    if (this.commonAncestorContainer.nodeName === 'LI' && this.commonAncestorContainer.parentElement && (this.commonAncestorContainer.parentElement.nodeName === 'OL' || this.commonAncestorContainer.parentElement.nodeName === 'UL')) {
      return wrapInFragment([wrapInList([wrapInLi([...contents.childNodes])], this.commonAncestorContainer.parentElement.nodeName)]);
    }
    return contents;
  };

  /**
   * Brings back the original `Range.prototype.cloneContents`.
   */
  return function undo() {
    Range.prototype.cloneContents = originalCloneContents;
  };
}